import { Typography, withStyles } from '@material-ui/core';
import React from 'react';

import styles from './styles';

const TableCellTypography = props => <Typography {...props} />;

export default withStyles(styles)(TableCellTypography);
